<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data" placeholder="请选择"
           :multiple='multiple' collapse-tags  @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in deviceType" :key="index"></el-option>
  </el-select>
</template>

<script>
    import { findList } from "@/services/customer";

    export default {
        name: 'MultipleType',
        props: {
            value: {},
            
            
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: true,
            },
            
        },

        data() {
            return {data: [], deviceType: []}
        },
        watch: {
            value:{
                immediate: true,
                handler(value) {
                  console.log(value,"ads")
                    this.data=value;
                }
            },
          
           
           
        },
        mounted() {
            this.loadData();
        },
        methods: {
           
            handleChange(value) {
                

                this.$emit("input",value);
                this.$emit("change", value)
                console.log(value,"value")
                this.data=value;
            },
            async loadData() {
               this.deviceType =[]
               this.data = [];
              
               const response = await findList( { page: 1, size: 1000,});
                console.log(response,"response")
                if (response&&response.code==0) {
                    this.deviceType = response.data.list.map((item, i) => {
                        return {name: item.name, value: item.id}
                    })
                }
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/MultipleClientName.vue